<zip-co-header></zip-co-header>

<main>
  <div class="container">
    <div class="left">
      <img
        class="unsuccessful-cloud-yellow"
        [src]="appPrefix + '/assets/shopping-teal.svg'"
        alt="pending"
      />
    </div>
    <div class="right">
      <h1>Sit tight, your order is being processed.</h1>

      <p>You will receive a confirmation of your order within the next 48 hours.</p>
      <p>
        Please don't hesitate to contact us <a href="https://help.zip.co/hc/en-us">here</a> if you
        have any concerns.
      </p>

      <a class="btn" routerLink="/au/giftcards"> Return to Gift Cards </a>
    </div>
  </div>
</main>

<app-footer></app-footer>
